import { TITLE_COPY_LIMITS } from "../copy-policy";
export const playgroundReelSchema = {
    componentId: "PlaygroundReel",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Reel",
            // The declaration under test: this slot takes ONLY a video.
            accepts: ["video"],
            unframed: true,
            targets: [],
        },
    ],
};
//# sourceMappingURL=playground-reel.js.map